import React from 'react';
import '../template-file-css/document-file-template.css';


export const NHBC_ClientHandbook = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NHBC_ClientHandbook' className='file-pdf-document'>

            <div className='file-template'>

                <h3>IMPORTANT INFORMATION FOR INDIVIDUALS SERVED & FAMILY MEMBERS</h3>
                <p className='w-750'>
                    530/542 Parkwood Way
                    Jonesboro, GA 30236 (Office)
                    or
                    101 Devant St. Suite 702
                    Fayetteville, GA 30214 (Office)
                    Phone (770) 460-0970
                    Fax (1) 866-758-5731

                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What rights do I have to receive services?</span>
                </p>
                <p className='w-750'>
                    Services at NHBC are available without regard to age, sex, gender identity, sexual orientation, race, creed, color, ancestry, national origin, disability, familial status, or marital status. Each individual has the right to request or refuse treatment to the
                    extent provided by law. The right to
                    treatment is not absolute, and under some
                    circumstances it may be in the best interest
                    of the client and the agency if the client is
                    referred elsewhere.
                </p>
                <p className='w-750'>
                    <ul>
                        <li> Confidentiality of records</li>
                        <li> Privacy</li>
                        <li> Freedom from abuse, financial and or other exploitation, retaliation, humiliation, and neglect</li>
                        <li> Access to information in a timely fashion needed to facilitate decision making</li>
                        <li> Informed consent or refusal of services, treatment, concurrent services, participation in research, or release of information</li>
                        <li> Expression of choice regarding the composition of the service deliver team</li>
                        <li> Access or referral to legal entities at the consumer's expense</li>
                        <li> Access and referral to selfhelp/advocacy support services</li>
                        <li> Adherence to research guidelines and ethics, if applicable</li>

                        <li> Investigation and resolution of alleged infringement of rights</li>
                        <li> Right to be free of physical holds (emergency intervention) seclusion or restraint</li>
                        <li> Right to be involved in treatment planning, review of the plan, and notification of changes</li>
                        <li> Right to be involved in transition planning</li>
                        <li> Right to file grievances without fear of reprisal</li>
                        <li> Right to obtain copies of the program's inspection, and accreditation reports upon written request within 30 days</li>
                        <li> Right to request in writing a review of the consumer's file and receive a response within 30 days. NHBC shall make determination using up-to-date HIPAA guidelines</li>
                        <li> Right to retain personal property that does not jeopardize the safety of others.</li>
                        <li> Right to be informed of all rights, and exercise rights without reprisal in any form. Clients may follow the grievance procedure to appeal restrictions placed on privileges. Grievances can be filed to Program manager for review. If no resolution, then to Clinical Director, Advisory Board, & DHS as needed (see policy & procedures & staff for more details)</li>
                    </ul>
                </p>
                <p className='w-750'>
                    <strong>*Any questions, concerns or grievances can be submitted to the Program Manager or (Clinical Director) (770) 460-0970 ext. 215
                    </strong>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What benefits are available for clients?</span>
                </p>
                <p className='w-750'>
                    At your first appointment, a licensed clinician
                    will work with you to determine the focus of
                    treatment based on your presenting problems,
                    needs, strengths, abilities, skills, and interests.
                    The assessment of clinical/medical necessity and
                    financial enrollment eligibility will also guide
                    what types of care and services are available.
                    You and your recovery team including
                    therapists, therapist's assistants, and other
                    clinical staff will assist you in developing your
                    treatment, transition, and discharge plans.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>OUR VISION:</span>
                </p>
                <p className='w-750'>
                    We believe that every individual served
                    should have a balanced and happy life.
                    Therefore, our vision is to "restore balance
                    and harmony" to the lives of the
                    individuals served and their families through
                    the use of quality counseling services.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>OUR MISSION:</span>
                </p>
                <p className='w-750'>
                    Our mission is to educate, empower, and to
                    expand the provision of effective counseling
                    techniques and interventions to address the
                    specific needs of individuals and families;
                    through culturally specific, clinically
                    relevant strategies and practices that
                    wholistically meets their recovery needs.
                    The results is restoring balance and harmony
                    to life and living one step at a time.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Where can I find a map of the premises?</span>
                </p>
                <p className='w-750'>
                    Every site has an evacuation map posted in
                    the lobby and/or major hallways that
                    provides information regarding the location
                    of restrooms, exits, and other relevant areas.
                    Exit signs may also be located by looking
                    for directional signs and/or lighted signs
                    within the suite.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>How much do services cost at New Heights Behavioral Consultants?
                    </span>
                </p>
                <p className='w-750'>
                    The cost of services at NHBC are affected
                    by several factors including the type of
                    services requested, the individuals  income
                    and number of dependents, insurance
                    coverage, and eligibility for governmental
                    assistance through medicaid or state grant
                    proceeds. NHBC makes every effort to
                    provide affordable services to its clients.
                    The agency accepts individuals enrolled in
                    private insurance, also Georgia Peachcare,
                    Amerigroup, Peachstate, Wellcare, as well
                    as those who are otherwise Medicaideligible.
                    Private insurance is also accepted.
                    Co-pays, when applicable are based on a
                    sliding-fee schedule.
                </p>
                <p className='w-750'>
                    NOTE: Service eligibility is determined by the funding
                    source.
                    <br />
                    Not every individual is eligible to
                    receive every service.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Are New Heights Services Confidential?
                    </span>
                </p>
                <p className='w-750'>
                    All services and written information at
                    NHBC are confidential as mandated by
                    federal and state laws and HIPAA
                    regulations. Charts will not be released
                    without the client's written consent, except
                    under the following circumstances:
                </p>
                <ul>
                    <li> Information from charts is requested
                        through a valid subpoena or court
                        order naming specific individual/s.</li>
                    <li> Child abuse or adult abuse is identified
                        or suspected.</li>
                    <li> The client is in a state of medical
                        emergency that necessitates disclosure
                        of information to medical personnel</li>
                    <li> If the client threatens to harm someone,
                        the intended victim and the police will
                        be notified or if client threatens to
                        harm themselves.</li>
                </ul>
                <p className='w-750'>
                    <span className='eleHeader'>What responsibilities do I have?</span>
                </p>
                <p className='w-750'>
                    At New Heights Behavioral Consultants clients are responsible for
                </p>
                <p className='w-750'>
                    <ul>
                        <li>Providing information necessary to
                            complete an appropriate comprehensive
                            clinical assessment & financial
                            assessment & to ensure proper
                            treatment</li>
                        <li>Working with the treatment team to
                            develop an individual treatment plan &
                            following the agreed tx.</li>
                        <li>Signing releases, consents, and other
                            paperwork necessary for continuity of
                            care</li>
                        <li> Treating other clients and all NHBC
                            staff in a respectful manner with dignity
                            and respect.</li>
                        <li> Clients have the responsibility to be a
                            full participant in the formulation of
                            their treatment Plan</li>
                        <li> Notifying the Clinical Director or Team
                            leader of any intention to discontinue
                            services</li>
                        <li> Refraining from bringing alcohol,
                            drugs, or weapons onto agency property</li>
                        <li> Arriving & being available on time for
                            appointments when scheduled with staff
                            members; or if unable to keep an appointment, calling 24 hours in
                            advance to cancel or reschedule.</li>
                        <li> Respecting other clients, staff with no
                            verbal or physical abuse</li>
                        <li> Clients have the responsibility to take
                            any prescribed medications in order to
                            advance in treatment.</li>
                        <li> Being truthful in reporting any
                            grievances or complaints to staff</li>
                        <li> In certain instances, it may be necessary
                            to restrict the rights & privileges of
                            clients & if restricted the client will be
                            notified at that time of how to regain
                            their rights & privileges.</li>
                    </ul>

                </p>

            </div>
        </form>

    )
} 
